import {GRANITE_1, GRANITE_3, SNOW_BLIND} from '@gaia/colors';
import GaiaIcon from '@gaia/icons/GaiaIcon';
import {ampli} from '@gaia/utils/gaia/trackAnalytics';
import {useSidebarInteractionSnackbarContext} from '@map/contexts/SidebarInteractionSnackbarContext';
import {IconButton, IconButtonProps, Tooltip} from '@mui/material';
import {useCallback} from 'react';

import ActionMenuButton from './ActionMenu/ActionMenuButton';

const tooltipStyle = {
    color: SNOW_BLIND,
    backgroundColor: GRANITE_1,
};

interface CopyCoordinatesProps extends IconButtonProps {
    coordinates: string;
    actionMenuButton?: boolean;
}

export default function CopyCoordinates({
    coordinates,
    actionMenuButton,
    ...props
}: CopyCoordinatesProps) {
    const [, setSnackbarState] = useSidebarInteractionSnackbarContext();
    const copyCoordinates = useCallback(async () => {
        if (!coordinates) return;
        await navigator.clipboard.writeText(coordinates);
        setSnackbarState({
            message: 'Copied to clipboard',
        });
        ampli.copyCoordinates();
    }, [coordinates, setSnackbarState]);

    if (actionMenuButton) {
        return (
            <ActionMenuButton
                dense
                icon={<GaiaIcon name='copy' />}
                label={'Copy Coordinates'}
                onClick={copyCoordinates}
            />
        );
    }

    return (
        <Tooltip
            id='copyCoords'
            title='Copy Coordinates'
            disableFocusListener
            componentsProps={{popper: {sx: {tooltipStyle}}}}
        >
            <IconButton
                aria-label='Click to copy coordinates'
                style={{
                    color: GRANITE_3,
                    height: 40,
                    width: 40,
                    ...props.style,
                }}
                onClick={copyCoordinates}
                size='large'
            >
                <GaiaIcon name='copy' />
            </IconButton>
        </Tooltip>
    );
}
